import * as React from "react"
import { Fragment } from "react"
import { useTranslate } from "ra-core"
import {
    BulkDeleteWithConfirmButton,
    DatagridConfigurable,
    List,
    //SearchInput,
    TopToolbar,
    CreateButton,
    FilterButton,
    SelectColumnsButton,
    ExportButton,
    TextField,
    TextInput,
    BooleanInput,
    EmailField,
    BooleanField,
    DateField,
    EditButton,
    WrapperField,
    ShowButton,
    BulkExportButton,
    usePermissions,
    ReferenceField,
} from "react-admin"
import * as buttons from "components/ui/buttons"

const getUserFilters = (permissions: string): React.ReactElement[] => {
    const filters = [
        // <SearchInput source="q" alwaysOn />,
        <TextInput source="name" />,
        <TextInput source="email" />,
        <TextInput source="login" />,
        <BooleanInput source="active" />,
        // <ReferenceInput source="customer_id" reference="customers" />,
    ]
    if (permissions === "admin") {
        filters.push(<TextInput source="role" />)
    }
    return filters
}


const ListActions = () => (
    <TopToolbar>
        <CreateButton />
        <FilterButton />
        <SelectColumnsButton />
        <ExportButton />
    </TopToolbar>
)
const PostBulkActionButtons = () => (
    <Fragment>
        <BulkExportButton />
        <BulkDeleteWithConfirmButton mutationMode="optimistic"/>
    </Fragment>
)

const UserList = () => {
    const { permissions } = usePermissions()
    const translate = useTranslate()

    return (
        <List
            filters={getUserFilters(permissions)}
            //filterDefaultValues={{ role: "user" }}
            sort={{ field: "created_at", order: "DESC" }}
            actions={<ListActions />}
        >
            <DatagridConfigurable sx={{
                "& .RaDatagrid-headerCell": { 
                    fontWeight: 'bold' 
                }
            }} bulkActionButtons={<PostBulkActionButtons/>}>
                <ReferenceField label={translate("resources.users.fields.login")} source="id" reference="users">
                    <TextField source="login" label={translate("resources.users.fields.login")} />
                </ReferenceField>
                <TextField source="name" label={translate("resources.users.fields.name")} />
                <EmailField source="email" label={translate("resources.users.fields.email")} />
                <BooleanField source="active" label={translate("resources.users.fields.active")} />
                <DateField showTime source="created_at" label={translate("resources.common.fields.created_at")}></DateField>
                <WrapperField label={translate("internal.actions")}>
                    <ShowButton label="" title={translate("ra.action.show")} />
                    <EditButton label="" title={translate("ra.action.edit")}/>
                    <buttons.DeleteWithConfirmButtonX title={translate("ra.action.remove")} field="login" />
                </WrapperField>
            </DatagridConfigurable>
        </List>
    )
}
//<buttons.EditButtonX resource="users"/>
export default UserList